import { render, staticRenderFns } from "./c_set_up.vue?vue&type=template&id=4e8ca2da&scoped=true"
import script from "./c_set_up.vue?vue&type=script&lang=js"
export * from "./c_set_up.vue?vue&type=script&lang=js"
import style0 from "./c_set_up.vue?vue&type=style&index=0&id=4e8ca2da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ca2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8ca2da')) {
      api.createRecord('4e8ca2da', component.options)
    } else {
      api.reload('4e8ca2da', component.options)
    }
    module.hot.accept("./c_set_up.vue?vue&type=template&id=4e8ca2da&scoped=true", function () {
      api.rerender('4e8ca2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_set_up.vue"
export default component.exports